module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kyousei-bfc4381e8f52c1b5f0d6116811cdf3cf.png";